import React from 'react';
import LimitTableFilter from '../../../components/limit/LimitTableFilter';
import styled from 'styled-components';

function ActionCostsLimitTable({ isRegion }: { isRegion?: boolean }) {
  return (
    <LimitTableFilter title="경매집행비용은" isRegion={isRegion}>
      <SingleRowTable>
        <TableRow>
          <SingleRowTableHeadCell width="100%">청구금액</SingleRowTableHeadCell>
          <SingleRowTableBodyCell width="100%">
            150,000,000 원
          </SingleRowTableBodyCell>
        </TableRow>
      </SingleRowTable>
    </LimitTableFilter>
  );
}

export default ActionCostsLimitTable;
interface WidthProps {
  width: string;
  name?: string;
}

const SingleRowTable = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const TableRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #222;
`;
const SingleRowTableHeadCell = styled.div<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 10px 12px;
  background-color: #f7f8fc;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18.85px;
  letter-spacing: -0.36px;
  color: #616161;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const SingleRowTableBodyCell = styled.div<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border-bottom: 1px solid #e8e9ea;
  padding: 6px 8px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px;
  letter-spacing: -0.32px;
  color: #616161;
`;
